import { BaseBookingModel } from '@xeetr/types/models'
import { DATE_FORMAT_LONGYEAR, DATE_FORMAT_SHORTYEAR } from '@xeetr/types/utils'
import { formatInTimeZone } from 'date-fns-tz'

import { useWindowSize } from '../../../hooks/common/useWindowSize'
import { useTenant } from '../../../hooks/useTenant'

export const DateColumn = (booking: BaseBookingModel) => {
  const { width } = useWindowSize()
  const { tenant } = useTenant()

  const timezone = tenant?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  return formatInTimeZone(
    booking.from,
    timezone,
    width > 425 ? DATE_FORMAT_LONGYEAR : DATE_FORMAT_SHORTYEAR
  )
}
